import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DoctorDashboardService {

  public baseUrl: string;
  public newbaseUrl: string;
  selecteBranchMasterData: any = {};
  constructor(public http: HttpClient, public authservice: AuthService) {
    this.baseUrl = this.authservice.baseUrl;
    this.newbaseUrl = this.authservice.newbaseUrl;
  }
  // GetDoctorDashBoard(fdate:any,todate:any,usertypeid: any) {
  //   return this.http.get<any>(this.newbaseUrl + "GetDoctorDashBoard/" + fdate +'/'+ todate +'/'+ usertypeid)
  // }
  GetDoctorDashBoardYear(fdate:any,doctorid:any,type: any) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetDoctorDashboard/" + fdate +'/'+ doctorid +'/'+ type)
  }
  GetDoctorDashBoardGraph(fdate:any,doctorid:any,type: any) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetDoctorDashboardgraph/" + fdate +'/'+ doctorid +'/'+ type)
  }
  
}